import { push } from 'connected-react-router';
import store from '../store'; 


export const url = {
    adjusterFees: '/payroll', 
    aiLab: '/ai-lab',
    aiLabCatalog: '/ai-lab/catalog',          
    aiLabDesigner: '/ai-lab/designer/:toolId?', 
    admin: '/admin',    
    ccpaScrub: '/admin/ccpa-scrub',
    claimProfile: '/claim/:claimId',
    claimList: '/claims',
    companies: '/admin/companies',    
    companyFileTypes: '/admin/company-file-types',
    companyDetail: '/admin/company/:companyId',
    contacts: '/admin/contacts',        
    contactDetail: '/admin/contacts/:contactId',
    dashboard: '/',
    documentTypes: '/admin/documentTypes',    
    financials: '/financials', 
    login: '/login',
    loginCallback: '/login_callback',
    logout: '/logout',
    notFound: '/404', 
    payroll: '/payroll', 
    printf: '/printf',
    queues: '/queues',    
    reports: '/reports',         
    security: '/security',
    unauthorized: '/unauthorized',    
};

export const goto = (path: string) => {
    store.dispatch(push(path));
};

export const gotoWithState = (path: string, state: object) => {
    store.dispatch(push(path, state));
};